/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedTourPlannerRouteImport } from './routes/_authenticated/tour-planner'
import { Route as AuthenticatedTourCuratorRouteImport } from './routes/_authenticated/tour-curator'
import { Route as AuthenticatedRoomCrawlerRouteImport } from './routes/_authenticated/room-crawler'
import { Route as AuthenticatedPromptsRouteImport } from './routes/_authenticated/prompts'
import { Route as AuthenticatedLiveToursRouteImport } from './routes/_authenticated/live-tours'
import { Route as AuthenticatedHelloRouteImport } from './routes/_authenticated/hello'
import { Route as AuthenticatedDocumentExportRouteImport } from './routes/_authenticated/document-export'
import { Route as AuthenticatedDisplaySettingsRouteImport } from './routes/_authenticated/display-settings'
import { Route as AuthenticatedDashboardsRouteImport } from './routes/_authenticated/dashboards'
import { Route as AuthenticatedComponentsRouteImport } from './routes/_authenticated/components'
import { Route as AuthenticatedBulkImportRouteImport } from './routes/_authenticated/bulk-import'
import { Route as AuthenticatedArtworkEditorRouteImport } from './routes/_authenticated/artwork-editor'
import { Route as AuthenticatedTourPlannerPlanIdRouteImport } from './routes/_authenticated/tour-planner_.$planId'
import { Route as AuthenticatedLiveToursTourIdRouteImport } from './routes/_authenticated/live-tours_.$tourId'
import { Route as AuthenticatedDisplaySettingsHomeScreenRouteImport } from './routes/_authenticated/display-settings_.home-screen'
import { Route as AuthenticatedArtworkEditorArkIdRouteImport } from './routes/_authenticated/artwork-editor_.$arkId'

const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTourPlannerRoute =
  AuthenticatedTourPlannerRouteImport.update({
    id: '/tour-planner',
    path: '/tour-planner',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTourCuratorRoute =
  AuthenticatedTourCuratorRouteImport.update({
    id: '/tour-curator',
    path: '/tour-curator',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRoomCrawlerRoute =
  AuthenticatedRoomCrawlerRouteImport.update({
    id: '/room-crawler',
    path: '/room-crawler',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPromptsRoute = AuthenticatedPromptsRouteImport.update({
  id: '/prompts',
  path: '/prompts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLiveToursRoute = AuthenticatedLiveToursRouteImport.update({
  id: '/live-tours',
  path: '/live-tours',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHelloRoute = AuthenticatedHelloRouteImport.update({
  id: '/hello',
  path: '/hello',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDocumentExportRoute =
  AuthenticatedDocumentExportRouteImport.update({
    id: '/document-export',
    path: '/document-export',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDisplaySettingsRoute =
  AuthenticatedDisplaySettingsRouteImport.update({
    id: '/display-settings',
    path: '/display-settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardsRoute = AuthenticatedDashboardsRouteImport.update({
  id: '/dashboards',
  path: '/dashboards',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedComponentsRoute = AuthenticatedComponentsRouteImport.update({
  id: '/components',
  path: '/components',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBulkImportRoute = AuthenticatedBulkImportRouteImport.update({
  id: '/bulk-import',
  path: '/bulk-import',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedArtworkEditorRoute =
  AuthenticatedArtworkEditorRouteImport.update({
    id: '/artwork-editor',
    path: '/artwork-editor',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTourPlannerPlanIdRoute =
  AuthenticatedTourPlannerPlanIdRouteImport.update({
    id: '/tour-planner_/$planId',
    path: '/tour-planner/$planId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLiveToursTourIdRoute =
  AuthenticatedLiveToursTourIdRouteImport.update({
    id: '/live-tours_/$tourId',
    path: '/live-tours/$tourId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDisplaySettingsHomeScreenRoute =
  AuthenticatedDisplaySettingsHomeScreenRouteImport.update({
    id: '/display-settings_/home-screen',
    path: '/display-settings/home-screen',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedArtworkEditorArkIdRoute =
  AuthenticatedArtworkEditorArkIdRouteImport.update({
    id: '/artwork-editor_/$arkId',
    path: '/artwork-editor/$arkId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/artwork-editor': typeof AuthenticatedArtworkEditorRoute
  '/bulk-import': typeof AuthenticatedBulkImportRoute
  '/components': typeof AuthenticatedComponentsRoute
  '/dashboards': typeof AuthenticatedDashboardsRoute
  '/display-settings': typeof AuthenticatedDisplaySettingsRoute
  '/document-export': typeof AuthenticatedDocumentExportRoute
  '/hello': typeof AuthenticatedHelloRoute
  '/live-tours': typeof AuthenticatedLiveToursRoute
  '/prompts': typeof AuthenticatedPromptsRoute
  '/room-crawler': typeof AuthenticatedRoomCrawlerRoute
  '/tour-curator': typeof AuthenticatedTourCuratorRoute
  '/tour-planner': typeof AuthenticatedTourPlannerRoute
  '/artwork-editor/$arkId': typeof AuthenticatedArtworkEditorArkIdRoute
  '/display-settings/home-screen': typeof AuthenticatedDisplaySettingsHomeScreenRoute
  '/live-tours/$tourId': typeof AuthenticatedLiveToursTourIdRoute
  '/tour-planner/$planId': typeof AuthenticatedTourPlannerPlanIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/artwork-editor': typeof AuthenticatedArtworkEditorRoute
  '/bulk-import': typeof AuthenticatedBulkImportRoute
  '/components': typeof AuthenticatedComponentsRoute
  '/dashboards': typeof AuthenticatedDashboardsRoute
  '/display-settings': typeof AuthenticatedDisplaySettingsRoute
  '/document-export': typeof AuthenticatedDocumentExportRoute
  '/hello': typeof AuthenticatedHelloRoute
  '/live-tours': typeof AuthenticatedLiveToursRoute
  '/prompts': typeof AuthenticatedPromptsRoute
  '/room-crawler': typeof AuthenticatedRoomCrawlerRoute
  '/tour-curator': typeof AuthenticatedTourCuratorRoute
  '/tour-planner': typeof AuthenticatedTourPlannerRoute
  '/artwork-editor/$arkId': typeof AuthenticatedArtworkEditorArkIdRoute
  '/display-settings/home-screen': typeof AuthenticatedDisplaySettingsHomeScreenRoute
  '/live-tours/$tourId': typeof AuthenticatedLiveToursTourIdRoute
  '/tour-planner/$planId': typeof AuthenticatedTourPlannerPlanIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/_authenticated/artwork-editor': typeof AuthenticatedArtworkEditorRoute
  '/_authenticated/bulk-import': typeof AuthenticatedBulkImportRoute
  '/_authenticated/components': typeof AuthenticatedComponentsRoute
  '/_authenticated/dashboards': typeof AuthenticatedDashboardsRoute
  '/_authenticated/display-settings': typeof AuthenticatedDisplaySettingsRoute
  '/_authenticated/document-export': typeof AuthenticatedDocumentExportRoute
  '/_authenticated/hello': typeof AuthenticatedHelloRoute
  '/_authenticated/live-tours': typeof AuthenticatedLiveToursRoute
  '/_authenticated/prompts': typeof AuthenticatedPromptsRoute
  '/_authenticated/room-crawler': typeof AuthenticatedRoomCrawlerRoute
  '/_authenticated/tour-curator': typeof AuthenticatedTourCuratorRoute
  '/_authenticated/tour-planner': typeof AuthenticatedTourPlannerRoute
  '/_authenticated/artwork-editor_/$arkId': typeof AuthenticatedArtworkEditorArkIdRoute
  '/_authenticated/display-settings_/home-screen': typeof AuthenticatedDisplaySettingsHomeScreenRoute
  '/_authenticated/live-tours_/$tourId': typeof AuthenticatedLiveToursTourIdRoute
  '/_authenticated/tour-planner_/$planId': typeof AuthenticatedTourPlannerPlanIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/no-access'
    | '/artwork-editor'
    | '/bulk-import'
    | '/components'
    | '/dashboards'
    | '/display-settings'
    | '/document-export'
    | '/hello'
    | '/live-tours'
    | '/prompts'
    | '/room-crawler'
    | '/tour-curator'
    | '/tour-planner'
    | '/artwork-editor/$arkId'
    | '/display-settings/home-screen'
    | '/live-tours/$tourId'
    | '/tour-planner/$planId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/no-access'
    | '/artwork-editor'
    | '/bulk-import'
    | '/components'
    | '/dashboards'
    | '/display-settings'
    | '/document-export'
    | '/hello'
    | '/live-tours'
    | '/prompts'
    | '/room-crawler'
    | '/tour-curator'
    | '/tour-planner'
    | '/artwork-editor/$arkId'
    | '/display-settings/home-screen'
    | '/live-tours/$tourId'
    | '/tour-planner/$planId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/no-access'
    | '/_authenticated/artwork-editor'
    | '/_authenticated/bulk-import'
    | '/_authenticated/components'
    | '/_authenticated/dashboards'
    | '/_authenticated/display-settings'
    | '/_authenticated/document-export'
    | '/_authenticated/hello'
    | '/_authenticated/live-tours'
    | '/_authenticated/prompts'
    | '/_authenticated/room-crawler'
    | '/_authenticated/tour-curator'
    | '/_authenticated/tour-planner'
    | '/_authenticated/artwork-editor_/$arkId'
    | '/_authenticated/display-settings_/home-screen'
    | '/_authenticated/live-tours_/$tourId'
    | '/_authenticated/tour-planner_/$planId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  NoAccessRoute: typeof NoAccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/tour-planner': {
      id: '/_authenticated/tour-planner'
      path: '/tour-planner'
      fullPath: '/tour-planner'
      preLoaderRoute: typeof AuthenticatedTourPlannerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tour-curator': {
      id: '/_authenticated/tour-curator'
      path: '/tour-curator'
      fullPath: '/tour-curator'
      preLoaderRoute: typeof AuthenticatedTourCuratorRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/room-crawler': {
      id: '/_authenticated/room-crawler'
      path: '/room-crawler'
      fullPath: '/room-crawler'
      preLoaderRoute: typeof AuthenticatedRoomCrawlerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/prompts': {
      id: '/_authenticated/prompts'
      path: '/prompts'
      fullPath: '/prompts'
      preLoaderRoute: typeof AuthenticatedPromptsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/live-tours': {
      id: '/_authenticated/live-tours'
      path: '/live-tours'
      fullPath: '/live-tours'
      preLoaderRoute: typeof AuthenticatedLiveToursRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hello': {
      id: '/_authenticated/hello'
      path: '/hello'
      fullPath: '/hello'
      preLoaderRoute: typeof AuthenticatedHelloRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/document-export': {
      id: '/_authenticated/document-export'
      path: '/document-export'
      fullPath: '/document-export'
      preLoaderRoute: typeof AuthenticatedDocumentExportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/display-settings': {
      id: '/_authenticated/display-settings'
      path: '/display-settings'
      fullPath: '/display-settings'
      preLoaderRoute: typeof AuthenticatedDisplaySettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboards': {
      id: '/_authenticated/dashboards'
      path: '/dashboards'
      fullPath: '/dashboards'
      preLoaderRoute: typeof AuthenticatedDashboardsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/components': {
      id: '/_authenticated/components'
      path: '/components'
      fullPath: '/components'
      preLoaderRoute: typeof AuthenticatedComponentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bulk-import': {
      id: '/_authenticated/bulk-import'
      path: '/bulk-import'
      fullPath: '/bulk-import'
      preLoaderRoute: typeof AuthenticatedBulkImportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/artwork-editor': {
      id: '/_authenticated/artwork-editor'
      path: '/artwork-editor'
      fullPath: '/artwork-editor'
      preLoaderRoute: typeof AuthenticatedArtworkEditorRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tour-planner_/$planId': {
      id: '/_authenticated/tour-planner_/$planId'
      path: '/tour-planner/$planId'
      fullPath: '/tour-planner/$planId'
      preLoaderRoute: typeof AuthenticatedTourPlannerPlanIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/live-tours_/$tourId': {
      id: '/_authenticated/live-tours_/$tourId'
      path: '/live-tours/$tourId'
      fullPath: '/live-tours/$tourId'
      preLoaderRoute: typeof AuthenticatedLiveToursTourIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/display-settings_/home-screen': {
      id: '/_authenticated/display-settings_/home-screen'
      path: '/display-settings/home-screen'
      fullPath: '/display-settings/home-screen'
      preLoaderRoute: typeof AuthenticatedDisplaySettingsHomeScreenRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/artwork-editor_/$arkId': {
      id: '/_authenticated/artwork-editor_/$arkId'
      path: '/artwork-editor/$arkId'
      fullPath: '/artwork-editor/$arkId'
      preLoaderRoute: typeof AuthenticatedArtworkEditorArkIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedArtworkEditorRoute: typeof AuthenticatedArtworkEditorRoute
  AuthenticatedBulkImportRoute: typeof AuthenticatedBulkImportRoute
  AuthenticatedComponentsRoute: typeof AuthenticatedComponentsRoute
  AuthenticatedDashboardsRoute: typeof AuthenticatedDashboardsRoute
  AuthenticatedDisplaySettingsRoute: typeof AuthenticatedDisplaySettingsRoute
  AuthenticatedDocumentExportRoute: typeof AuthenticatedDocumentExportRoute
  AuthenticatedHelloRoute: typeof AuthenticatedHelloRoute
  AuthenticatedLiveToursRoute: typeof AuthenticatedLiveToursRoute
  AuthenticatedPromptsRoute: typeof AuthenticatedPromptsRoute
  AuthenticatedRoomCrawlerRoute: typeof AuthenticatedRoomCrawlerRoute
  AuthenticatedTourCuratorRoute: typeof AuthenticatedTourCuratorRoute
  AuthenticatedTourPlannerRoute: typeof AuthenticatedTourPlannerRoute
  AuthenticatedArtworkEditorArkIdRoute: typeof AuthenticatedArtworkEditorArkIdRoute
  AuthenticatedDisplaySettingsHomeScreenRoute: typeof AuthenticatedDisplaySettingsHomeScreenRoute
  AuthenticatedLiveToursTourIdRoute: typeof AuthenticatedLiveToursTourIdRoute
  AuthenticatedTourPlannerPlanIdRoute: typeof AuthenticatedTourPlannerPlanIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedArtworkEditorRoute: AuthenticatedArtworkEditorRoute,
  AuthenticatedBulkImportRoute: AuthenticatedBulkImportRoute,
  AuthenticatedComponentsRoute: AuthenticatedComponentsRoute,
  AuthenticatedDashboardsRoute: AuthenticatedDashboardsRoute,
  AuthenticatedDisplaySettingsRoute: AuthenticatedDisplaySettingsRoute,
  AuthenticatedDocumentExportRoute: AuthenticatedDocumentExportRoute,
  AuthenticatedHelloRoute: AuthenticatedHelloRoute,
  AuthenticatedLiveToursRoute: AuthenticatedLiveToursRoute,
  AuthenticatedPromptsRoute: AuthenticatedPromptsRoute,
  AuthenticatedRoomCrawlerRoute: AuthenticatedRoomCrawlerRoute,
  AuthenticatedTourCuratorRoute: AuthenticatedTourCuratorRoute,
  AuthenticatedTourPlannerRoute: AuthenticatedTourPlannerRoute,
  AuthenticatedArtworkEditorArkIdRoute: AuthenticatedArtworkEditorArkIdRoute,
  AuthenticatedDisplaySettingsHomeScreenRoute:
    AuthenticatedDisplaySettingsHomeScreenRoute,
  AuthenticatedLiveToursTourIdRoute: AuthenticatedLiveToursTourIdRoute,
  AuthenticatedTourPlannerPlanIdRoute: AuthenticatedTourPlannerPlanIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  NoAccessRoute: NoAccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
